import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-white pt-16 pb-8 border-t border-gray-900" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-122">
          {/* Brand */}
          <div data-id="element-123">
            <div className="flex items-center gap-3 mb-6" data-id="element-124">
              <div className="relative w-10 h-10 overflow-hidden rounded-full border border-[#00D4FF] bg-black" data-id="element-125">
                <img src="https://cdn.magicpatterns.com/uploads/fmBXjQm2BPtC5bTSRKvwCz/walkerlogo-gigapixel-cgi-3600w.png" alt="Walker's Martial Arts Logo" className="w-full h-full object-cover" data-id="element-126" />
              </div>
              <div className="flex flex-col" data-id="element-127">
                <span className="text-white font-bold text-base leading-none tracking-wide uppercase" data-id="element-128">
                  Walker's
                </span>
                <span className="text-[#00D4FF] font-bold text-xs leading-none tracking-wider uppercase" data-id="element-129">
                  Martial Arts
                </span>
              </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-xs" data-id="element-130">
              "Where Families Kick Together"
              <br data-id="element-131" />
              Proudly serving the Bloomington community and surrounding area
              since 1999.
            </p>
            <div className="flex gap-4" data-id="element-132">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-[#00D4FF] hover:text-black transition-all" data-id="element-133">
                <Facebook size={20} data-id="element-134" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-[#00D4FF] hover:text-black transition-all" data-id="element-135">
                <Instagram size={20} data-id="element-136" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div data-id="element-137">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-138">
              Contact Us
            </h4>
            <ul className="space-y-4 text-gray-400" data-id="element-139">
              <li className="flex items-start gap-3" data-id="element-140">
                <MapPin className="w-5 h-5 text-[#00D4FF] shrink-0 mt-1" data-id="element-141" />
                <span className="text-sm" data-id="element-142">
                  1304 E. Empire Suite 2.
                  <br data-id="element-143" />
                  Bloomington, Illinois 61701
                  <br data-id="element-144" />
                  <span className="text-xs text-gray-500" data-id="element-145">
                    (Inside the Regions Bank Complex at the intersection of
                    Empire & Towanda)
                  </span>
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-146">
                <Phone className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-147" />
                <a href="tel:3092422440" className="hover:text-white transition-colors" data-id="element-148">
                  (309) 242-2440
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-149">
                <Mail className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-150" />
                <a href="mailto:walkerskicks@gmail.com" className="hover:text-white transition-colors" data-id="element-151">
                  walkerskicks@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-152">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-153">
              Class Hours
            </h4>
            <ul className="space-y-2 text-gray-400" data-id="element-154">
              <li className="flex justify-between" data-id="element-155">
                <span data-id="element-156">Monday - Thursday</span>
                <span className="text-white" data-id="element-157">5:00 AM - 9:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-158">
                <span data-id="element-159">Friday</span>
                <span className="text-white" data-id="element-160">5:00 AM - 7:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-161">
                <span data-id="element-162">Saturday</span>
                <span className="text-white" data-id="element-163">9:00 AM - 2:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-164">
                <span data-id="element-165">Sunday</span>
                <span className="text-white" data-id="element-166">8:00 AM - 12:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-167">
          <p data-id="element-168">
            &copy; {new Date().getFullYear()} Walker's Martial Arts. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-169">
            <a href="#" className="hover:text-white transition-colors" data-id="element-170">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-171">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}